import { LocalDataError } from '../types.js';
import { newId } from '../domain/ids.js';
import { nowIso } from '../domain/time.js';
export class SessionRepository {
    driver;
    constructor(driver) {
        this.driver = driver;
    }
    async start(userId, expiresAt) {
        const user = await this.driver.query({
            sql: 'SELECT is_active FROM users WHERE id = ?',
            params: [userId],
        });
        if (!user[0] || Number(user[0].is_active) !== 1) {
            throw new LocalDataError('USER_UNAVAILABLE', 'That user cannot sign in on this device');
        }
        const now = nowIso();
        const id = newId();
        // No RETURNING: minSdk 26 SQLite predates it (ADR-002); insert then read.
        const results = await this.driver.batch([
            {
                sql: `INSERT INTO local_session (id, user_id, started_at, last_used_at, expires_at)
              VALUES (?, ?, ?, ?, ?)`,
                params: [id, userId, now, now, expiresAt],
            },
            { sql: 'SELECT * FROM local_session WHERE id = ?', params: [id] },
        ]);
        return mapRow(results[1]?.rows[0] ?? {});
    }
    async touch(id) {
        await this.driver.execute({
            sql: 'UPDATE local_session SET last_used_at = ? WHERE id = ? AND ended_at IS NULL',
            params: [nowIso(), id],
        });
    }
    async end(id) {
        await this.driver.execute({
            sql: 'UPDATE local_session SET ended_at = ? WHERE id = ? AND ended_at IS NULL',
            params: [nowIso(), id],
        });
    }
    /** The live (not ended, not expired) session, if any. */
    async active(at = nowIso()) {
        const rows = await this.driver.query({
            sql: `SELECT * FROM local_session
            WHERE ended_at IS NULL AND expires_at > ?
            ORDER BY started_at DESC LIMIT 1`,
            params: [at],
        });
        return rows[0] ? mapRow(rows[0]) : null;
    }
}
function mapRow(r) {
    return {
        id: String(r.id),
        userId: String(r.user_id),
        startedAt: String(r.started_at),
        lastUsedAt: String(r.last_used_at),
        expiresAt: String(r.expires_at),
        endedAt: r.ended_at == null ? null : String(r.ended_at),
    };
}
//# sourceMappingURL=sessions.js.map